module.exports = __webpack_public_path__ + "img/christin-hume-Hcfwew744z4-unsplash.4ebfb3b2.jpg";